/*
 * Marionette LayoutView: DialogPopover
 * -------------------------
 * Marionette Layout view extended to work as our implementation of Bootstrap Popover
 */

import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import LayoutMixin from '@/views/dashboard/mixins/layout';
import template from '@/../templates/dashboard/group.hbs';

    var DashboardGroup = Marionette.View.extend(LayoutMixin).extend({
        options: {
            content: Marionette.View.extend({
                template: '<div>No Content</div>'
            }),
            width: 'full'
        },
        ui: {
            content : '.content-region',
            links : '.links'
        },
        template: Handlebars.compile(template),
        className: function() { return 'group ' + this.getWidth(); },
        regions: {
            content : '.content-region',
            links : '.links'
        },
        templateContext: function() {
            var data = {
                title: this.options.title,
                width: this.getWidth(),
                links: this.options.links
            };

            if (data.title || data.links) {
                data.has_header = true;
            }

            return data;
        },

        onAttach: function() {
            if (!this.options.widgets) {
                this.showChildView('content', new this.options.content());
            } else {
                _.each(this.options.widgets, function(widget, index) {
                    this.ui.content.append('<div class="widget' + index + '"></div>');
                    this.addRegion('widget' + index, '.widget' + index)
                        .show(widget);
                }, this);
            }

            if (this.options.links) {
                _.each(this.options.links, function(link, index) {
                    var html = '<span class="link' + index + '"></span>';

                    if (index + 1 !== this.options.links.length) {
                        html += ' | ';
                    }

                    this.ui.links.append(html);

                    this.addRegion('link' + index, '.link' + index)
                        .show(link);
                }, this);
            }
        }
    });
    export default DashboardGroup;

